














































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BCard,
  BCardHeader,
  BCardGroup,
  BCardBody,
  BCol,
  BRow,
  BFormCheckbox,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BAlert,
  BFormInvalidFeedback,
  BSpinner,
  VBTooltip,
} from "bootstrap-vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import { FormWizard, TabContent } from "vue-form-wizard";
import { Site } from "@/api/models/sites/site";
import { Planning, PlanningIntervenant } from "@/api/models/planning/planning";
import {
  typePlanning,
  typePlanningNumnberToEnum,
} from "@/api/models/enums/typePlanningEnum";
import {
  AccesPlateformeBeneficiaire,
  PriseDeRdvSitesConfig,
  PriseRdvConfigurationModel,
} from "@/api/models/accesPlateformeBeneficiaires/accesPlateformeBeneficiaire";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import PriseRdvConfig from "./priseRdv/PriseRdvConfig.vue";
import NewsConfig from "./news/NewsConfig.vue";
import ApplicationsConfig from "./applications/ApplicationsConfig.vue";
import SmsConfig from "./sms/SmsConfig.vue";

@Component({
  components: {
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardGroup,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BAlert,
    BFormInvalidFeedback,
    BSpinner,
    BListGroup,
    BListGroupItem,
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    SearchableVueSelect,
    FeatherIcon,
    PriseRdvConfig,
    NewsConfig,
    ApplicationsConfig,
    SmsConfig,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
})
export default class AccesPlateforme extends Vue {
  wizardKey: string = 'acces-plateforme-wizard';
  // PROPRIÉTÉS PRINCIPALES
  @Prop({ required: true }) adherent!: Entreprise;
  typesPlanning = typePlanning;

  // ÉTATS UI
  showEspaceBeneficiaire = false;
  showEspaceAdherent = false;
  loading = false;
  showAlertCode: boolean | null = null;
  rdv: boolean = false;

  // ÉTATS DE CHARGEMENT
  loadingSites: boolean = false;
  loadingIntervenants: boolean = false;
  loadingConfig: boolean = false;
  loadingTags: boolean = false;
  loadingDownload: boolean = false;
  timeout: any;

  // DONNÉES MODEL
  model: AccesPlateformeBeneficiaire = {
    id: this.adherent.idAccesPlateformeBeneficiaire!,
    nom: this.adherent.libelleAccesPlateformeBeneficiaire!,
    codeInscription: this.adherent.codeAccesPlateformeBeneficiaire!,
    priseDeRdvConfig: this.adherent.priseDeRdvConfig,
    dateDerniereModificationPriseDeRdvConfig: this.adherent
      .dateDerniereModificationPriseDeRdvConfig,
    dateDerniereSynchroPriseDeRdvConfig: this.adherent
      .dateDerniereSynchroPriseDeRdvConfig,
    entrepriseId: this.$route.params.id,
    actif: true,
    newsActive: this.adherent.newsActive,
    featureLinkApplicationActive: this.adherent.featureLinkApplicationActive,
    newsTags: this.adherent.newsTags,
    applicationsAutorisees: this.adherent.applicationsAutorisees || [],
    smsActive: this.adherent.smsActive ?? false,
  };

  // DONNÉES SITES
  sitesConfig: PriseDeRdvSitesConfig[] = [];

  // DONNÉES PLANNINGS
  intervenantsConfig: PlanningIntervenant[] = [];
  private loadingIntervenantsFromWatcher: boolean = false;

  tagsList: string[] = [];

  getSitesSmartAgenda () {
    return this.sitesConfig.filter(s => s.idSmartAgenda != null)
  }

  get sitesLibelles() {
    return this.getSitesSmartAgenda().map(s => s.libelle).join(", ")
  }

  get newsTagsLibelles() {
    return this.tagsList.join(", ")
  }

  get intervenantsLibelles() {
    return this.intervenantsConfig
      .map(i => `${i.nom} ${i.prenom}`)
      .join(", ")
  }

  async created() {
    this.loadingConfig = true;
    
    if (
      this.adherent.codeAccesPlateformeBeneficiaire &&
      this.adherent.actifAccesPlateformeBeneficiaire
    ) {
      this.showEspaceBeneficiaire = true;
      if (this.hasActivePriseRdvConfiguration()) {
        await this.getConfiguredSitesAndIntervenants();
        this.rdv = true;
      } else {
        this.loadSites();
      }
    }
    await this.loadTagsList();
    
    this.loadingConfig = false;
  }

  scrollToSectionListSites () {
    this.$emit("scroll-to-section-list-sites")
  }

  scrollToSectionIntervenants() {
    this.$emit("scroll-to-section-intervenants")
  }

  goToParametres() {
    const routeData = this.$router.resolve({ name: 'admin-parametres' }) 
    window.open(routeData.href, '_blank')
  }

  async downloadFlyer() {
    this.loadingDownload = true;
    
    try {
      this.$http.myressif.accesPlateformeBeneficiaire.downloadFlyer(
        this.$route.params.id
      )
      .then((response: any) => {
        var blob = new Blob([response], { type: 'application/pdf;' });
        console.log(blob)
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        var date = new Date();
        link.setAttribute('download', `flyer.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de télécharger le flyer",
        });
      })
      .finally(() => {
        this.loadingDownload = false;
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'actualisation",
        text: "Impossible d'actualiser les données.",
      });
      this.loadingDownload = false;
    }
  }

  // WATCHERS
  @Watch("model.codeInscription")
  async codeChange() {
    this.loading = true;
    this.showAlertCode = null;
    await this.checkCodeExistant();
  }

  @Watch("sitesConfig", { immediate: false })
  async onSitesConfigChange(): Promise<void> {
    if (this.loadingIntervenantsFromWatcher) {
      return;
    }

    if (this.sitesConfig.length > 0) {
      await this.loadPlannings();
    } else {
      this.intervenantsConfig = [];
    }
  }

  async loadTagsList() {
    this.loadingTags = true;
    this.$http.myressif.parametres
      .getByNom("news_tags_list")
      .then((tags: any) => {
        this.tagsList = JSON.parse(tags?.valeur ?? "[]");
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de charger la liste des tags.",
        });
      })
      .finally(() => {
        this.loadingTags = false;
      });
  }

  // MÉTHODES POUR LES SITES
  async loadSites() {
    this.loadingSites = true;
    this.sitesConfig = [];

    try {
      const sites = await this.$http.myressif.entreprises.getListSitesByEntrepriseId(
        this.$route.params.id
      );
      this.sitesConfig = sites.map((site: Site) => ({
        id: site.id,
        libelle: site.libelle,
        idSmartAgenda: site.idCategorieSmartAgenda,
        selected: false,
      }));
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de chargement",
        text: "Impossible de charger les sites de l'entreprise.",
      });
    } finally {
      this.loadingSites = false;
    }
  }

  handleSiteSelection(site: PriseDeRdvSitesConfig): void {
    if (!site.idSmartAgenda) return;

    this.sitesConfig = [...this.sitesConfig];
  }

  // MÉTHODES POUR LES PLANNINGS
  async loadPlannings(): Promise<void> {
    this.loadingIntervenants = true;
    const existingSelected = new Map();

    this.intervenantsConfig.forEach((i) => {
      if (i.selected) {
        existingSelected.set(i.idPlanning, i);
      }
    });

    this.intervenantsConfig = [];

    try {
      const selectedSites = this.sitesConfig.filter((s) => s.selected);

      const planningsArrays = await this.$http.myressif.entreprises.getPlanningsBySitesIds(
        this.$route.params.id,
        selectedSites.map((s) => s.id)
      );

      const addedPlanningsMap = new Map();

      planningsArrays.forEach((planning: any, index: number) => {
        if (addedPlanningsMap.has(planning.id)) return;
        addedPlanningsMap.set(planning.id, true);

        const existingIntervenant = existingSelected.get(planning.id);

        this.intervenantsConfig.push({
          idPlanning: planning.id!,
          entrepriseId: this.adherent.id,
          entrepriseLibelle: this.adherent.libelle,
          siteId: planning.site.id,
          siteLibelle: planning.site.libelle,
          siteIdSmartAgenda: planning.site.idCategorieSmartAgenda,
          utilisateurId: planning.utilisateurId!,
          utilisateurIdSmartAgenda: planning.utilisateur?.idSmartAgenda || "",
          nom: planning.utilisateur?.nom || "",
          prenom: planning.utilisateur?.prenom || "",
          email: planning.utilisateur?.email || "",
          mission:
            existingIntervenant?.mission ||
            this.getDefaultMission(parseInt(planning.type?.toString()!)),
          codeFonction: this.getCodeFonction(planning.type),
          planningType: parseInt(planning.type?.toString()!),
          selected: existingIntervenant ? true : false,
        });
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de chargement",
        text: "Impossible de charger les intervenants.",
      });
    } finally {
      this.loadingIntervenants = false;
    }
  }

  mapIntervenantToViewModel(planning: Planning): PlanningIntervenant {
    return {
      idPlanning: planning.id!,
      entrepriseId: this.adherent.id,
      entrepriseLibelle: this.adherent.libelle,
      siteId: planning.site?.id!,
      siteLibelle: planning.site?.libelle || "",
      siteIdSmartAgenda: planning.site?.idCategorieSmartAgenda!,
      utilisateurId: planning.utilisateurId!,
      utilisateurIdSmartAgenda: planning.utilisateur?.idSmartAgenda || "",
      nom: planning.utilisateur?.nom || "",
      prenom: planning.utilisateur?.prenom || "",
      email: planning.utilisateur?.email || "",
      mission: this.getDefaultMission(parseInt(planning.type?.toString()!)),
      codeFonction: this.getCodeFonction(parseInt(planning.type?.toString()!)),
      planningType: parseInt(planning.type?.toString()!),
      selected: false,
    };
  }

  handleIntervenantSelection(intervenant: PlanningIntervenant): void {
    const index = this.intervenantsConfig.findIndex(
      (p) => p.idPlanning === intervenant.idPlanning
    );

    if (intervenant.selected && index === -1) {
      this.intervenantsConfig.push({
        idPlanning: intervenant.idPlanning,
        entrepriseId: this.adherent.id,
        entrepriseLibelle: this.adherent.libelle,
        siteId: intervenant.siteId,
        siteLibelle: intervenant.siteLibelle,
        siteIdSmartAgenda: intervenant.siteIdSmartAgenda,
        utilisateurId: intervenant.utilisateurId,
        utilisateurIdSmartAgenda: intervenant.utilisateurIdSmartAgenda,
        nom: intervenant.nom,
        prenom: intervenant.prenom,
        email: intervenant.email,
        codeFonction: intervenant.codeFonction,
        mission: intervenant.mission,
      });
    } else if (!intervenant.selected && index !== -1) {
      this.intervenantsConfig.splice(index, 1);
    }
  }

  isIntervenantSelected(planningId: string): boolean {
    const intervenant = this.intervenantsConfig.find((i) => i.idPlanning === planningId);
    return !!intervenant?.selected;
  }

  getDefaultMission(type: number): string {
    const typePlanningValue =
      typePlanningNumnberToEnum[type as keyof typeof typePlanningNumnberToEnum];

    switch (typePlanningValue) {
      case this.typesPlanning.ASST:
        return "Assistant-e de service social";
      case this.typesPlanning.IST:
        return "Infirmier-e en santé travail";
      case this.typesPlanning.PSY:
        return "Psychologue du travail";
      default:
        return "Consultant-e";
    }
  }

  getCodeFonction(typePlanning: number): string {
    const typePlanningValue =
      typePlanningNumnberToEnum[typePlanning as keyof typeof typePlanningNumnberToEnum];

    switch (typePlanningValue) {
      case this.typesPlanning.ASST:
        return "ASST";
      case this.typesPlanning.IST:
        return "IST";
      case this.typesPlanning.PSY:
        return "PSY";
      default:
        return "CONS";
    }
  }

  getIntervenantMission(planningId: string): string {
    const configuredIntervenant = this.intervenantsConfig.find(
      (i) => i.idPlanning === planningId
    );
    if (configuredIntervenant) {
      return configuredIntervenant.mission;
    }

    const intervenant = this.intervenantsConfig.find((i) => i.idPlanning === planningId);
    return intervenant ? intervenant.mission : "";
  }

  updateIntervenantMission(planningId: string, newMission: string): void {
    const intervenant = this.intervenantsConfig.find((i) => i.idPlanning === planningId);
    if (intervenant) {
      intervenant.mission = newMission;
    }
    const configIndex = this.intervenantsConfig.findIndex(
      (i) => i.idPlanning === planningId
    );
    if (configIndex !== -1) {
      this.intervenantsConfig[configIndex].mission = newMission;
    }
  }

  getIntervenantsByFilter(
    collection: PlanningIntervenant[],
    siteId: string
  ): PlanningIntervenant[] {
    return collection.filter((intervenant) => intervenant.siteId === siteId);
  }

  getAvailableIntervenantsBySite(siteId: string): PlanningIntervenant[] {
    return this.intervenantsConfig.filter((i) => i.siteId === siteId);
  }

  getSelectedIntervenants(): PlanningIntervenant[] {
    return this.intervenantsConfig.filter((i) => i.selected);
  }

  getSelectedIntervenantsBySite(siteId: string): PlanningIntervenant[] {
    return this.intervenantsConfig.filter((i) => i.siteId === siteId && i.selected);
  }

  // GESTION DE CONFIGURATION
  editCurrentConfiguration(): void {
    this.loadingSites = true;
    this.loadingIntervenantsFromWatcher = true;

    this.$http.myressif.entreprises
      .getListSitesByEntrepriseId(this.$route.params.id)
      .then((sites: Site[]) => {
        const configuredSiteIds = this.model.priseDeRdvConfig?.intervenants
          ? [...new Set(this.model.priseDeRdvConfig.intervenants.map((i) => i.siteId))]
          : [];

        this.sitesConfig = sites.map((site: Site) => ({
          id: site.id,
          libelle: site.libelle,
          idSmartAgenda: site.idCategorieSmartAgenda,
          selected: configuredSiteIds.includes(site.id) && !!site.idCategorieSmartAgenda,
        }));
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de charger les sites de l'entreprise.",
        });
      })
      .finally(() => {
        this.loadingSites = false;
        this.$bvModal.show("rdv-stepper-modal");
        this.loadPlannings().finally(() => {
          if (this.model.priseDeRdvConfig?.intervenants) {
            this.model.priseDeRdvConfig.intervenants.forEach((configIntervenant) => {
              const intervenant = this.intervenantsConfig.find(
                (i) => i.idPlanning === configIntervenant.idPlanning
              );

              if (intervenant) {
                intervenant.selected = true;
                intervenant.mission = configIntervenant.mission;
              }
            });
          }

          this.loadingIntervenantsFromWatcher = false;
        });
      });
  }

  async getConfiguredSitesAndIntervenants() {
    if (!this.hasActivePriseRdvConfiguration()) return [];

    try {
      const sitesMap = new Map<string, PriseDeRdvSitesConfig>();

      this.model.priseDeRdvConfig?.intervenants.forEach((i) => {
        if (!sitesMap.has(i.siteId)) {
          sitesMap.set(i.siteId, {
            id: i.siteId,
            libelle: i.siteLibelle,
            idSmartAgenda: i.siteIdSmartAgenda,
            selected: true,
          });
        }
      });

      this.sitesConfig = Array.from(sitesMap.values());
      this.intervenantsConfig = this.model.priseDeRdvConfig?.intervenants.map((i) => ({
        ...i,
        selected: true,
      }))!;

      return;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de chargement",
        text: "Impossible de charger les sites et plannings configurés.",
      });
      return [];
    }
  }

  hasActivePriseRdvConfiguration(): boolean {
    return (
      this.model.priseDeRdvConfig != null &&
      this.model.priseDeRdvConfig.intervenants.length > 0
    );
  }

  // GESTION MODALES ET UI
  async disableRdvConfiguration() {
    try {
      await this.$http.myressif.accesPlateformeBeneficiaire.updatePriseDeRdv(
        this.model.id!,
        null
      );

      await this.$http.myressif.accesPlateformeBeneficiaire.syncPriseDeRdvConfig(
        this.model.id!
      );

      successAlert.fire({
        title: "Configuration de la prise de rendez-vous",
        text: "Configuration enregistrée avec succès.",
      });

      this.rdv = false;

      this.resetPriseRdvModel();

      this.reloadAdherent();

      return true;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'enregistrement",
        text: error?.response?.data?.detail || error.message,
      });
      return false;
    }
  }

  reloadAdherent() {
    this.$emit("reload-adherent");
    setTimeout(async () => {
      await this.reloadModel();
    }, 2000);
  }

  handleRdvModalClose(): void {
    this.resetPriseRdvModel();
    this.reloadAdherent();
  }

  resetPriseRdvModel(): void {
    this.intervenantsConfig = [];
    this.sitesConfig = [];
    this.model.priseDeRdvConfig = null;
    this.loadingSites = false;
    this.loadingIntervenants = false;
    this.rdv = false;
  }

  // SAUVEGARDER ET SYNCHRONISER
  async saveRdvConfiguration() {
    const selectedSites = this.sitesConfig.filter((s) => s.selected);
    if (selectedSites.length === 0) {
      errorAlert.fire({
        title: "Attention",
        text: "Veuillez sélectionner au moins un site pour la prise de rendez-vous.",
      });
      return false;
    }

    const selectedIntervenants = this.intervenantsConfig.filter((i) => i.selected);

    if (selectedIntervenants.length === 0) {
      errorAlert.fire({
        title: "Attention",
        text:
          "Veuillez sélectionner au moins un intervenant pour la prise de rendez-vous.",
      });
      return false;
    }

    const configuration: PriseRdvConfigurationModel = {
      intervenants: selectedIntervenants.map((intervenant) => ({
        idPlanning: intervenant.idPlanning,
        entrepriseId: this.adherent.id,
        entrepriseLibelle: this.adherent.libelle,
        mission: intervenant.mission,
        siteId: intervenant.siteId,
        siteLibelle: intervenant.siteLibelle,
        siteIdSmartAgenda: intervenant.siteIdSmartAgenda,
        nom: intervenant.nom,
        prenom: intervenant.prenom,
        email: intervenant.email,
        codeFonction: intervenant.codeFonction,
        utilisateurId: intervenant.utilisateurId,
        utilisateurIdSmartAgenda: intervenant.utilisateurIdSmartAgenda,
      })),
    };

    try {
      await this.$http.myressif.accesPlateformeBeneficiaire.updatePriseDeRdv(
        this.model.id!,
        configuration
      );

      successAlert.fire({
        title: "Configuration de la prise de rendez-vous",
        text: "Configuration enregistrée avec succès.",
      });

      this.$bvModal.hide("rdv-stepper-modal");
      this.reloadAdherent();

      return true;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'enregistrement",
        text: error?.response?.data?.detail || error.message,
      });
      return false;
    }
  }

  async syncRdvConfiguration() {
    try {
      await this.saveRdvConfiguration();

      await this.$http.myressif.accesPlateformeBeneficiaire.syncPriseDeRdvConfig(
        this.model.id!
      );

      successAlert.fire({
        title: "Synchronisation de la prise de rendez-vous",
        text: "Synchronisation effectuée avec succès.",
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de synchronisation",
        text: error?.response?.data?.detail || error.message,
      });
    } finally {
      this.reloadAdherent();
    }
  }

  // GESTION DES ACCÈS À LA PLATEFORME
  async checkCodeExistant() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.model.codeInscription) {
        try {
          const response = await this.$http.myressif.accesPlateformeBeneficiaire.getByCode(
            this.model.codeInscription
          );

          if (
            this.model.codeInscription === this.adherent.codeAccesPlateformeBeneficiaire
          ) {
            this.showAlertCode = false;
          } else {
            this.showAlertCode = !!response;
          }
        } finally {
          this.loading = false;
        }
      }
    }, 2000);
  }

  toggleEspaceBeneficiaire() {
    if (this.showEspaceBeneficiaire) {
      if (this.adherent.idAccesPlateformeBeneficiaire != null) {
        this.model.actif = true;
        this.update();
      } else {
        this.$bvModal.show("AddAccesPlateformeModal");
      }
    } else {
      this.confirmEspaceBeneficiaireDisable();
    }
  }

  confirmEspaceBeneficiaireDisable() {
    this.$bvModal
      .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer cet accès ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then((value) => {
        if (value === true) {
          this.model.actif = false;
          this.update();
        } else {
          this.showEspaceBeneficiaire = true;
        }
      });
  }

  // ACTIONS DE FORMULAIRE
  async submit() {
    try {
      await this.$http.myressif.accesPlateformeBeneficiaire.post(this.model);

      this.showEspaceBeneficiaire = true;
      successAlert.fire({
        timer: 3500,
        title: "Création d'un accès à l'espace bénéficiaire",
        text: "Accès créé avec succès",
      });
    } catch (error: any) {
      if (
        error?.response?.data?.errors &&
        Object.keys(error.response.data.errors).length
      ) {
        errorAlert.fire({
          text: error.response.data.errors[Object.keys(error.response.data.errors)[0]],
        });
      } else {
        errorAlert.fire({
          text: error?.response?.data?.detail ?? error.message,
        });
      }
    } finally {
      this.reloadAdherent();
    }
  }

  async update() {
    try {
      await this.$http.myressif.accesPlateformeBeneficiaire.update(
        this.adherent.idAccesPlateformeBeneficiaire!,
        this.model
      );

      successAlert.fire({
        timer: 3500,
        title: "Mise à jour d'un accès à l'espace bénéficiaire",
        text: "Accès mis à jour avec succès",
      });
    } catch (error: any) {
      if (
        error?.response?.data?.errors &&
        Object.keys(error.response.data.errors).length
      ) {
        errorAlert.fire({
          text: error.response.data.errors[Object.keys(error.response.data.errors)[0]],
        });
      } else {
        errorAlert.fire({
          text: error?.response?.data?.detail ?? error.message,
        });
      }
    } finally {
      this.reloadAdherent();
    }
  }

  // GESTION MODAL
  async closeModal() {
    await this.reloadModel();
    this.showEspaceBeneficiaire = false;
    this.$bvModal.hide("AddAccesPlateformeModal");
  }

  async handleClose() {
    await this.reloadModel();
    this.showEspaceBeneficiaire = false;
  }

  async reloadModel() {
    this.loadingConfig = true;
    this.model = {
      id: this.adherent.idAccesPlateformeBeneficiaire!,
      nom: this.adherent.libelleAccesPlateformeBeneficiaire!,
      codeInscription: this.adherent.codeAccesPlateformeBeneficiaire!,
      entrepriseId: this.$route.params.id,
      priseDeRdvConfig: this.adherent.priseDeRdvConfig,
      dateDerniereModificationPriseDeRdvConfig: this.adherent
        .dateDerniereModificationPriseDeRdvConfig,
      dateDerniereSynchroPriseDeRdvConfig: this.adherent
        .dateDerniereSynchroPriseDeRdvConfig,
      actif: this.adherent.actifAccesPlateformeBeneficiaire,
      featureLinkApplicationActive: this.adherent.featureLinkApplicationActive,
      newsActive: this.adherent.newsActive,
      newsTags: this.adherent.newsTags || [],
      applicationsAutorisees: this.adherent.applicationsAutorisees || [],
      smsActive: this.adherent.smsActive ?? false,
    };

    if (this.adherent.priseDeRdvConfig) {
      await this.getConfiguredSitesAndIntervenants();

      this.rdv = true;
    }
    this.loadingConfig = false;
    this.loading = false;
  }
}
